module.exports = __webpack_public_path__ + "fonts/quicksand-latin-700-normal.af49c83.woff2";